import styled from "styled-components";

export const StyledLogo = styled.div`
    display: inline-flex;
    svg {
        display: block;
        .icon-sky {
            fill: ${({ theme, variant }) => variant === 'white' ? theme.colors.white : theme.colors.purple}
        }
        .icon-do {
            fill: ${({ theme }) => theme.colors.blue}
        }
    }
    ${({ customStyle }) => customStyle && customStyle};
`;
